var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48419 9.42756L9.79874 5.11301C9.07291 4.80979 8.41369 4.36701 7.85848 3.80978C7.30098 3.25444 6.85799 2.59501 6.55466 1.86893L2.24011 6.18348C1.90351 6.52008 1.73492 6.68867 1.59024 6.87418C1.41955 7.09322 1.27305 7.33008 1.15331 7.58063C1.05238 7.79298 0.97713 8.01932 0.826622 8.47085L0.0320823 10.8527C-0.0044865 10.9618 -0.00991203 11.0789 0.0164154 11.1908C0.0427429 11.3028 0.0997798 11.4052 0.181115 11.4866C0.26245 11.5679 0.364859 11.6249 0.47683 11.6513C0.588802 11.6776 0.705898 11.6722 0.814955 11.6356L3.19682 10.841C3.64893 10.6905 3.87469 10.6153 4.08704 10.5144C4.33866 10.3946 4.57414 10.2489 4.79349 10.0774C4.979 9.93275 5.14759 9.76416 5.48419 9.42756ZM10.9958 3.91595C11.426 3.48576 11.6677 2.90229 11.6677 2.29391C11.6677 1.68553 11.426 1.10206 10.9958 0.671871C10.5656 0.241679 9.98214 4.53281e-09 9.37376 0C8.76538 -4.53281e-09 8.18191 0.241679 7.75172 0.671871L7.23428 1.18931L7.25644 1.25407C7.51137 1.98372 7.92866 2.64596 8.47684 3.19083C9.038 3.75542 9.72342 4.18094 10.4784 4.43339L10.9958 3.91595Z",
    fill: "#573B76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.856552e0e5012839ad1ccb447d66164b.svg";
export { ForwardRef as ReactComponent };